import { checkUniqueNotCaseSensitive } from '../../../../Shared/Forms/FormValidation';
import { getIntl } from '../../../../Shared/localization';

export const uniquePathNameValidator = (value, _, props, formFieldName) => {
  if (value && props.payload && props.payload.outcomes && props.payload.outcomes.length) {
    const existingValues = props.payload.outcomes
      .filter(
        x =>
          x.arguments.branchResult !== formFieldName &&
          ![undefined, null].some(empty => x.metaData.label === empty)
      )
      .map(x => x.metaData.label);

    return checkUniqueNotCaseSensitive(value, existingValues);
  }
};

export const emptyRequiredFieldValidator = options =>
  options.length < 1 &&
  getIntl().formatMessage({
    id: 'journeyBuilder.decisionSplit_requiredFieldValidationMessage',
  });



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/validators.js